import axios from '../axios'
import Vue from 'vue'

export const getCurBalance = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/account/balance',
    method: 'get'
  })
}

export const rechargeAlipay = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/alipay/recharge',
    method: 'post',
    data
  })
}
export const rechargeWeChat = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/wechatpay/recharge',
    method: 'post',
    data
  })
}

export const getRechargeRecord = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/pay/rechargeinfo',
    method: 'get',
    params: data
  })
}

export const getRechargeRecordBySearch = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/pay/rechargesearch',
    method: 'get',
    params: data
  })
}
export const getCostRecord = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/stat/consumeinfo',
    method: 'get',
    params: data
  })
}
export const queryWxChatResult = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/wechatpay/resultquery',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/recharge.js